import { SvgComponentProps } from "@/src/types/SVGPropType"
import * as React from "react"
const MetaBusinessSVG: React.FC<SvgComponentProps> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={14}
    height={14}
    fill="none"
    {...props}
  >
    <path
      fill="url(#a)"
      d="m.898 7.105.022.006A7.639 7.639 0 0 1 6.9 13.07l.003.011v.003c.099.373.192.386.29.04a7.636 7.636 0 0 1 5.976-6.009l.003-.001c.38-.1.387-.194.019-.295A7.637 7.637 0 0 1 7.195.81L7.194.807C7.1.477 7.01.479 6.916.81l-.005.02L6.89.92l-.002.004c-.01.049-.02.097-.032.146l-.002.013A7.638 7.638 0 0 1 1.236 6.75c-.001 0-.005 0-.008.002-.09.022-.182.042-.274.06H.953l-.012.003-.003.001c-.372.098-.386.19-.04.288v.002Z"
    />
    <defs>
      <radialGradient
        id="a"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="rotate(-90 9.635 .115) scale(10.0938)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F0FCFF" />
        <stop offset={0.672} stopColor="#9BEDFF" />
        <stop offset={0.76} stopColor="#98ECFF" />
        <stop offset={0.849} stopColor="#5BE1FF" />
        <stop offset={0.948} stopColor="#00BAE2" />
      </radialGradient>
    </defs>
  </svg>
)
export default MetaBusinessSVG
